// extracted by mini-css-extract-plugin
export var dateLabel = "_2f-0";
export var dateLabelError = "_2f-1";
export var fullWidth = "_2f-2";
export var smaller = "_2f-3";